<template>
  <div>
    <!--Stripe de Centro de Innovación-->
    
    
    <!--Fin Stripe de Centro de Innovación-->

    <div class="login">      
      <div class="contenedor">
        <div class="contenedor-up">
          

          

        </div>
        <div class="contenedor-down">
          <div class="welcome_title">
            <h1>Soporte</h1>
            <span>LIGA MX - Siente tu app</span>
          </div>

          <div class="row">
            <div class="col s12 ">
              <div class="card">
                <div style="text-align: center;">
                  <img :src="require('../../assets/images/Logo-liga.png')" width="40%"/>
                </div>
                <div class="card-content">
                  <p>El fútbol evoluciona y LIGA MX también. Unimos fans y pasiones, porque el fútbol de México lo hacemos entre todos y todas. En esta nueva experiencia podrás seguir a tus clubes favoritos en las tres ligas principales del país: Liga BBVA MX, Liga BBVA MX Femenil y Liga BBVA Expansión MX, todo en el mismo lugar. </p>
                </div>
                <!--div class="card-action">
                  <a href="#">Click para descargar</a>
                </div-->
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col s12 ">
              <div class="card">
                <div class="card-content">
                  <p>Una nueva experiencia, todas las ligas. </p>
                </div>
                <!--div class="card-action">
                  <a href="#">Click para descargar</a>
                </div-->
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <!-- <h2>{{$store.getters.citeCurrentDivision}}</h2>  
  <button  @click="chooseYourDivision(1)"> cambiar</button>-->
</template>

<script>
import "../../assets/css/market_fresh.css";
import "../../assets/css/divisions.css";

export default {
  name: "skeleton",
  data: () => ({}),
  components: {
  
  },
  props: {},
  methods: {
    chooseYourDivision(idDivision) {
      this.$store.dispatch("DIVISION_SELECT", idDivision);
      this.$router.push("/chooseYourTeams");
    },
    vr(){
      window.location.href= 'https://citec.futbol/jagomez/cursor.html'
    }
  },
  watch: {},
  mounted() {}
};
</script>

<style>
</style>
